import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48af3b42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_container_with_720" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrandHours = _resolveComponent("BrandHours")!
  const _component_MediaNews = _resolveComponent("MediaNews")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BrandHours),
    _createVNode(_component_MediaNews)
  ]))
}